//
import WarehouseModel from '@/models/Warehouse/WhWarehouse'

//
export default ({ g_branch_office_id }) => [
    {
        name: 'wh_warehouse_id',
        props: {
            chips: true,
            itemText: 'name',
            itemValue: 'id',
            label: 'Bodega',
            model: WarehouseModel,
            noAsyncSearch: true,
            noObject: true,
            paramFilter: {
                g_branch_office_id,
            },
        },
        type: 'autocomplete-model',
    },
    {
        name: 'start',
        props: {
            label: 'Inicio',
        },
        type: 'date-field',
    },
    {
        name: 'end',
        props: {
            label: 'Termino',
        },
        type: 'date-field',
    },
]
